import type { BodyMapComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const bodyMapDuplicate: DuplicationHandler<BodyMapComponentSpec> = (spec) => {
  spec.queryId = crypto.randomUUID();
};
